<div class="page-container" [ngClass]="layoutClass">
  <div class="page-content">
    <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
    @if (!isIframe) {
      <router-outlet></router-outlet>
    }
  </div>
  <app-page-footer></app-page-footer>
</div>
